import messages from 'i18n/messages'
import flowRight from 'lodash/flowRight'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import React, { Component } from 'react'
import { Button, Form, Spinner } from 'reactstrap'
import { FormattedMessage, injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import update from 'immutability-helper'
import { makeSelectAppliedDiscountCampaign } from '../logic/payment'

const VoucherCodeBtn = ({ handleShowInput }) => (
  <Button className="btn-block btn-primary" onClick={handleShowInput}>
    <FormattedMessage {...messages.voucherOrPromoCode} />
  </Button>
)

const EnterVoucherCode = ({ inputChanged, loading, inputRef, error, handleSubmit, value, formatMessage }) => {
  if (error) {
    if (messages[error])
      value = formatMessage(messages[error])
    else
      value = error
  }

  return (
    <Form className="voucher-or-discount-form" onSubmit={handleSubmit}>
      <input
        type="text"
        onChange={inputChanged}
        value={value}
        ref={inputRef}
        disabled={loading}
        className={classNames('voucher-or-discount-input', { error })}
        placeholder={formatMessage(messages.enterYourCode)}
      />
      <button type="submit" className="verify-btn">
        { loading
          ? <Spinner style={{ width: '1em', height: '1em' }} name="ball-triangle-path" color="white" />
          : <FormattedMessage {...messages.verify} />
        }
      </button>
    </Form>
  )
}

const VOUCHER_CHARS = 'ABCDEFGHJKLMNPQRSTUVWXYZ0123456789'
const VOUCHER_REGEX = new RegExp(`[${VOUCHER_CHARS}]{3}-[${VOUCHER_CHARS}]{5}-[${VOUCHER_CHARS}]{4}`)

class VoucherOrDiscount extends Component {

  state = {
    code: '',
    error: null,
    showInput: false,
  }

  inputRef = React.createRef()

  componentDidUpdate (prevProps) {
    if (this.props.discountCampaign && this.state.showInput) {
      this.setState(update(this.state, { showInput: { $set: false }}))
    }
    if (prevProps.codeError === this.props.codeError || !this.props.codeError) return

    const errorText = this.selectErrorMsgFromStatusCode(this.props.codeError)
    this.setState(update(this.state, { error: { $set: errorText } }), () => setTimeout(this.resetError, 2000))
  }

  errorMsgDict = {
    404: 'invalidCode',
    409: 'limitExceeded',
  }

  selectErrorMsgFromStatusCode = error => this.errorMsgDict[error.status] || (error.body && error.body.error) || 'unknown'

  handleShowInput = () => this.setState(update(this.state, { showInput: { $set: !this.state.showInput }}), this.setInputFocus)

  handleSubmit = e => {
    e.preventDefault()
    const c = this.state.code
    if (VOUCHER_REGEX.test(c)) return this.props.checkVoucherCode(c)
    
    this.props.checkPromoCode(c)
  }

  resetError = () => this.setState(update(this.state, { error: { $set: null } }), this.setInputFocus)

  setInputFocus = () => this.inputRef.current ? this.inputRef.current.focus() : null

  handleChangeCode = ({ target }) => this.setState(update(this.state, { code: { $set: target.value } }))

  render() {
    return (
      <div className="voucher-or-discount">
        { this.state.showInput
          ? <EnterVoucherCode
              handleShowInput={this.handleShowInput}
              handleSubmit={this.handleSubmit}
              inputChanged={this.handleChangeCode}
              inputRef={this.inputRef}
              loading={this.props.loading}
              formatMessage={this.props.intl.formatMessage}
              error={this.state.error}
              value={this.state.code}
            />
          : <VoucherCodeBtn handleShowInput={this.handleShowInput} />
        }
      </div>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  discountCampaign: makeSelectAppliedDiscountCampaign(),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
  }, dispatch)
})

const enhance = flowRight(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps)
)

VoucherOrDiscount.propTypes = {
  loading: PropTypes.bool.isRequired,
  codeError: PropTypes.object,
  checkPromoCode: PropTypes.func.isRequired,
  checkVoucherCode: PropTypes.func.isRequired,
}

export default enhance(VoucherOrDiscount)
